export default (event, listeners = {}) => {
    let target = event.target;
    let action = target.getAttribute('data-v-action');
    if (!action) {
        target = event.target.closest('a, button');
        if (target) {
            action = target.getAttribute('data-v-action');
        }
    }
    if (action && typeof listeners[action] === 'function') {
        event.preventDefault();
        event.stopPropagation();
        listeners[action]();
    }
};